<template>
  <v-card rounded="xl" flat class="pa-2" color="#EFEFEF">
    <v-card-title
      class="pa-1 text-body-2"
      style="color: #33B6B0;"
    >
      {{ config.title }}
    </v-card-title>
    <v-divider class="my-1"/>
    <v-card-text
      class="text-body-2 grey-7--text pa-1 text-pre-line"
      v-text="displayContent"
    />
    <v-card-actions class="pa-1">
      <template v-if="config.to">
        <v-btn
          color="#33B6B0"
          dark
          class="text-body-2"
          elevation="0"
          block
          small
          :to="{ name: config.to }"
        >
          {{ config.buttonTitle }} ▶
        </v-btn>
      </template>
      <template v-else-if="config.link">
        <v-btn
          color="#33B6B0"
          dark
          class="text-body-2"
          elevation="0"
          block
          small
          :href="config.link"
          target="_blank"
        >
          {{ config.buttonTitle }} ▶
        </v-btn>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
// 若有 $enum.DENTCO_CS_LINE 請自行引入
export default {
  name: 'NotificationMessage',
  props: {
    type: {
      type: String,
      required: true,
    },
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    config() {
      // 依 type 回傳對應設定
      const configs = {
        system: {
          title: '系統公告',
          buttonTitle: '了解更多',
          to: 'notice',
          truncateLength: 20,
        },
        booking: {
          title: '全院線上預約通知',
          buttonTitle: '觀看詳情',
          to: 'onlineReserve',
        },
        reschedule: {
          title: '全院病患改約通知',
          buttonTitle: '觀看詳情',
          to: 'reschedule',
        },
        review_negative_internal: {
          title: '全院即時負評通知',
          buttonTitle: '看看AI建議您如何回覆',
          to: 'reviewList',
        },
        review_negative_google: {
          title: '全院即時負評通知',
          buttonTitle: '看看AI建議您如何回覆',
          to: 'googleReviewList',
        },
        post_treatment_care: {
          title: '術後關懷回報',
          buttonTitle: '觀看詳情',
          to: 'operativeCare',
        },
        pre_treatment_care: {
          title: '術前關懷回報',
          buttonTitle: '觀看詳情',
          to: 'operativeCare',
        },
        line_quota_full: {
          title: 'LINE訊息量不足',
          buttonTitle: '前往儲值',
          link: 'https://manager.line.biz/',
        },
        sms_quota_full: {
          title: '簡訊點數不足',
          buttonTitle: '前往儲值',
          link: this.$enum.DENTCO_CS_LINE,
        },
      };
      return configs[this.type] || {};
    },
    displayContent() {
      const content = this.message.content || '';
      const len = this.config.truncateLength;
      if (typeof len === 'number' && len > 0) {
        return content.length > len ? content.slice(0, len) + '……' : content;
      }
      return content;
    },
  },
};
</script>
